// src/components/NotFound/index.js
import React from 'react';
import './style.css';

export default class NotFound extends React.Component {
	constructor(props) {
		super(props);

		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleChangeInput = this.handleChangeInput.bind(this);

		this.state = {
			inputValue: ''
		};
	}

	handleSubmit(event) {
		alert("Formulář byl odeslán s:" + this.state.inputValue);
		event.preventDefault();
	}

	handleChangeInput(event) {
		this.setState({
			inputValue: event.target.value
		});
	}

	render() {
		return (
			<div className="container body">
				<div className="main-container">
					{/* page content */}
					<div className="col-md-12">
						<div className="col-middle">
							<div className="text-center text-center">
								<h1 className="error-number">404</h1>
								<h2>Sorry but we couldn't find this page</h2>
								<p>This page you are looking for does not exist <a href="#">Report this?</a>
								</p>
								<div className="mid-center">
									<h3>Search</h3>
									<form onSubmit={this.handleSubmit}>
										<div className="col-xs-12 form-group pull-right top-search">
											<div className="input-group">
												<input type="text" className="form-control" placeholder="Search for..."
													   value={this.state.inputValue}
													   onChange={this.handleChangeInput}
												/>
												<span className="input-group-btn">
													<button className="btn btn-default" type="button" onClick={this.handleSubmit}>
														Go!
													</button>
												</span>
											</div>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
					{/* /page content */}
				</div>
			</div>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./src/containers/NotFound/index.js
 **/